import { Injectable, inject } from '@angular/core';
import { SessionStorage, SessionStorageService, SignalStateProperty } from '@mwe/utils';
import { Address, Product, createAddress } from '@mwe/models';
import { ProductConsumptionLogic } from './product-consumption.logic';
import { ProductsWhiteListLogic } from '../products-white-list.logic';
import { filterStromGasWaermeProducts } from '@mwe/utils';

const productsKey = 'consumption_products';
const addressKey = 'consumption_address';
const preselectedProductKey = 'consumption_preselected_product';
const directAddressSelectionKey = 'direct_address_selection_key';

@Injectable({
  providedIn: 'root',
})
export class ConsumptionStateService {
  private storage = inject(SessionStorageService);
  private productsWhiteListLogic = inject(ProductsWhiteListLogic);
  private productConsumptionLogic = inject(ProductConsumptionLogic);

  @SessionStorage(productsKey)
  private _products: Product[];

  get products(): Product[] {
    return this._products && this.productConsumptionLogic.sortProducts(this._products);
  }

  set products(products: Product[]) {
    const productsWhiteListed = this.productsWhiteListLogic.removeNotWhiteListedProducts(products);
    this._products = filterStromGasWaermeProducts(productsWhiteListed);
  }

  @SessionStorage(addressKey)
  private _address: Address;

  get address(): Address {
    return this._address && createAddress(this._address);
  }

  set address(address: Address) {
    this._address = address;
  }

  @SessionStorage(preselectedProductKey)
  private _preselectedProduct: Product;

  get preselectedProduct(): Product {
    return this._preselectedProduct;
  }

  set preselectedProduct(preselectedProduct: Product) {
    this._preselectedProduct = preselectedProduct;
  }

  @SessionStorage(directAddressSelectionKey)
  private _consumptionDirectAddressSelection: boolean;

  @SignalStateProperty()
  get directAddressSelection(): boolean {
    return this._consumptionDirectAddressSelection;
  }

  set directAddressSelection(isDirectAddressSelection: boolean) {
    this._consumptionDirectAddressSelection = isDirectAddressSelection;
  }

  clearData(): void {
    this.storage.clear(productsKey);
    this.storage.clear(addressKey);
    this.storage.clear(preselectedProductKey);
    this.storage.clear(directAddressSelectionKey);
  }
}
